import { render, staticRenderFns } from "./VisitCard.vue?vue&type=template&id=f31c13ea"
import script from "./VisitCard.vue?vue&type=script&lang=js"
export * from "./VisitCard.vue?vue&type=script&lang=js"
import style0 from "./VisitCard.vue?vue&type=style&index=0&id=f31c13ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports